import React, { cloneElement } from 'react';
import SidebarItem from '../../components/SidebarItem';
import ResourceDataMap from '../../components/ResourceDataMap';
import { links } from 'routes/navigation/sidebarLinks';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import './style.css';

const SidebarWrapper = styled.div`
  @media (max-width: 768px) {
    display: none;
  }
`;

const SidebarComponent = ({
  activeLinkColor,
  activeLinkBgColor,
  colorOnHover,
  linkColor,
  openedMenu,
}) => {
  const ClonedSidebarItem = ({ linkItem }) =>
    cloneElement(<SidebarItem linkItem={linkItem} openedMenu={openedMenu} inDossier={false} />, {
      activeLinkColor,
      activeLinkBgColor,
      colorOnHover,
      linkColor,
    });

  return (
    <div className={`sidebar-shell hideScrollbar ${openedMenu ? 'is-collapsed' : ''}`}>
      <SidebarWrapper className="sidebar-nav-scroll">
        <ResourceDataMap
          resourceData={links}
          resourceItem={ClonedSidebarItem}
          resourceName="linkItem"
        />
      </SidebarWrapper>
    </div>
  );
};

SidebarComponent.propTypes = {
  activeLinkColor: PropTypes.string.isRequired,
  activeLinkBgColor: PropTypes.string.isRequired,
  colorOnHover: PropTypes.string.isRequired,
  linkColor: PropTypes.string.isRequired,
  openedMenu: PropTypes.bool.isRequired,
};

export default SidebarComponent;
